import { Swiper, SwiperSlide } from 'swiper/react';
import { Image } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css'; // Swiper styles
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/swiper-bundle.css';
import 'swiper/css/pagination';


function ImageSlider({ dataObj }) {

    return (
        <Swiper
            modules={[Navigation, Autoplay, Pagination]}
            spaceBetween={20}
            slidesPerView={dataObj.home_no_items ? dataObj.home_no_items : "1.5"}
            navigation={(dataObj.home_slider_hide_arrow)==1?false:true}
            pagination={dataObj.home_slider_hide_dots ? false : { clickable: true }}
            loop={"true"}
            speed={3000} // Transition speed in ms
            autoplay={{
                delay: 1500, // 1.5 seconds
                disableOnInteraction: false,
            }}
            breakpoints={{
                0: {
                    slidesPerView: dataObj.home_no_items_mobile,
                },
                768: {
                    slidesPerView: dataObj.home_no_items_tablet,
                },
                1024: {
                    slidesPerView: dataObj.home_no_items ? Number(dataObj.home_no_items) : 3,
                },
            }}

        >
            {dataObj.gallery_items.map((value) => {
                return (
                    <SwiperSlide>
                        <div className='joyful_item2'>
                            <Image src={value.home_gallery_image_url} />
                        </div>
                    </SwiperSlide>
                )
            })}
        </Swiper>
    )
}

export default ImageSlider